export default __webpack_public_path__ + "static/16_34-a76b9ad5e67349d104feffcd19054826.png";